import React from 'react';
import Icon from '../../../components/AppIcon';

const ClaimRewardModal = ({ isOpen, onClose, pointsAwarded, tierName, tierIcon }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-sm rounded-2xl overflow-hidden border border-white/20 shadow-2xl bg-gradient-to-br from-accent via-accent to-accent/70 p-8 text-center">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.25),transparent_60%)]" />
        <div className="relative">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-white/15 flex items-center justify-center ring-4 ring-white/20">
            <Icon name={tierIcon || 'Award'} size={30} className="text-white" />
          </div>
          <p className="text-white/80 text-xs font-medium uppercase tracking-wide mb-1">
            Weekly Streak Complete
          </p>
          <h2 className="text-2xl font-bold text-white mb-1">+{pointsAwarded} NESOL</h2>
          <p className="text-white/90 text-sm mb-6">
            You've climbed to <span className="font-semibold">{tierName}</span>. Keep the streak alive!
          </p>
          <button
            onClick={onClose}
            className="w-full py-2.5 rounded-lg bg-white text-accent font-semibold text-sm hover:bg-white/90 transition-smooth"
          >
            Nice!
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClaimRewardModal;